import { Link } from "react-router-dom";
import { articles } from "@/mocks/videoData";

export default function NewsSection() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              影视资讯
            </h2>
            <p className="text-sm text-foreground-600 mt-1">最新影视动态、深度影评和观影指南</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articles.slice(0, 3).map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden hover:shadow-md transition-shadow cursor-pointer"
            >
              <div className="relative overflow-hidden aspect-[16/9]">
                <img
                  src={article.thumbnail}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-primary-500 bg-primary-100 px-2 py-0.5 rounded font-medium">
                    {article.category === "movie" ? "电影" : article.category === "tv" ? "电视剧" : article.category === "anime" ? "动漫" : article.category === "documentary" ? "纪录片" : "资讯"}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-600 line-clamp-2">
                  {article.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}